import * as React from 'react';

import { LodgingPill, Pill } from 'components/common/schema-types/buttons/lodging-pill';

interface OffersFilterPillsProps {
  pills?: Pill[];
  onClick: () => void;
}

export const OffersFilterPills: React.FunctionComponent<OffersFilterPillsProps> = props => {
  const { pills, onClick } = props;

  if (!pills || pills.length === 0) {
    return null;
  }

  return (
    <div className="all-b-margin-three all-t-margin-one">
      {pills.map((pill, index) => {
        const { type, value } = pill;

        return (
          <LodgingPill
            key={`offer-pill-${index}`}
            model={pill}
            pillType="removablePill"
            pillProps={{
              id: `${type}-${value}`,
              onClick,
            }}
            referrerId={`RoomFilter.${value}.Off`}
            replace={true}
          />
        );
      })}
    </div>
  );
};
OffersFilterPills.displayName = 'OffersFilterPills';
